<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

 <!-- style="margin-bottom:-0.5em;" -->


<!-- <div class="columns is-multiline is-gapless" style="">
<div class="column is-6"></div>
<div class="column is-1 colBorderThin has-text-centered isLabel">Sess-Ann</div>
<div class="column is-1 colBorderThin has-text-centered isLabel">Grp Avg.</div>
<div class="column is-2 colBorderThin has-text-centered isLabel">Stud Avg.</div>
<div class="column is-1 colBorderThin has-text-centered isLabel">Remark</div>
</div> -->


<div @click="toggle_ponderation_notes()" class="columns colBorderDark is-multiline is-gapless isLink hoverIt">






<div class="column is-6 colBorderThin">
<div class="columns is-multiline is-gapless" style="">

<div v-if="data.group_LANG=='F'" class="column is-12 is-size-5 has-text-weight-bold">&nbsp;{{data.cour_TITRE_F}}</div>
<div v-else class="column is-12 is-size-5 has-text-weight-bold">&nbsp;{{data.cour_TITRE_E}}</div>

<div style="margin-top:-.2em;" class="column is-6 is-size-6 isLabel">&nbsp;{{data.cour_CODE}}</div>
<div style="margin-top:-.2em;" class="column is-6 is-size-6 isLabel has-text-right">{{data.group_CODE}}&nbsp;</div>

</div></div>

<!-- <div class="column is-8 is-size-6 has-text-weight-semibold has-text-grey">&nbsp;{{data.prof1}}&nbsp;&nbsp;{{data.prof2}}
<span class="is-size-7 isLabel"> : {{data.group_CODE}}</span>
</div> -->

<div class="column is-1 is-size-4  has-background-light has-text-centered colBorderThin">
<div class="columns is-multiline is-gapless" style="">
    <div class="column is-12 colBorderThin has-text-centered isLabel is-size-7 has-text-light has-background-grey-light">Sess-Ann</div>
    <div class="column is-12 has-text-centered">{{data.group_SESS}}-{{data.group_ANN}}</div>
</div>
</div>

<div style="margin-top:0em;" class="column is-1 is-size-4 has-text-weight-bold has-background-light has-text-centered colBorderThin">
<div class="columns is-multiline is-gapless" style="">
    <div class="column is-12 colBorderThin has-text-centered isLabel is-size-7 has-text-light has-background-grey-light">Grp. Avg.</div>
    <div class="column is-12 has-text-centered">{{return_average(data.group_AVG)}}</div>
</div>
</div>

<div class="column is-1 colBorderThin"></div>

<!-- <div :style="return_course_style_complete()" class="column is-2 is-size-6 has-text-weight-bold  colBorderThin has-text-centered">{{return_course_average()}}</div> -->      
<div class="column is-1 is-size-4 has-text-weight-bold  has-text-centered">
<div class="columns is-multiline is-gapless" style="">
    <div class="column is-12 colBorderThin has-text-centered isLabel is-size-7">Stud. Avg.</div>
    <div class="column is-12 has-text-centered" :class="return_course_style_note()">{{return_average(data.cs_MARK)}} </div>
</div>
</div> 

<div style="margin-top:0em;" class="column is-1 is-size-4 has-text-weight-bold has-text-centered colBorderThin">
<div class="columns is-multiline is-gapless" style="">
    <div class="column is-12 colBorderThin has-text-centered isLabel is-size-7">Remark</div>
    <div class="column is-12 has-text-centered">{{data.cs_REMARK}} </div>
</div>
</div>



</div>








<!-- <div class="column is-3 colBorderThin">
<div class="columns is-vcentered" style="margin-top:.1em;">
    <div class="column is-12 is-size-5 has-text-centered" :class="return_course_style_note()">
      {{return_course_note()}}  
    </div>
</div>
</div> -->


<div v-if="show_notes == true" class="columns is-multiline is-gapless" style="margin-top:-1.6em;margin-bottom:2em;">
<div class="column is-12">
    <CourseListPond v-if="load_pond" :student_id="data.studID"  :group_id="data.grpID" :group_avg="data.group_AVG" course_title=""
    @emit_note_change="emit_note_change"></CourseListPond>
</div>

    <div class="column is-11 has-text-centered">

<table class="table">
  <thead>
    <tr>
        <th v-for ="(info, index) in data_dates" :key="index">
            <div class="columns is-gapless is-multiline">
                <div class="column is-12 has-text-centered">{{moment(info.schedMain_date).format('MMM')}}</div>
                <div class="column is-12 has-text-centered">{{moment(info.schedMain_date).format('DD')}}</div>
            </div>
        </th>
    </tr>
  </thead>
  <tbody>
    <tr>
        <td v-for ="(info, index) in data_dates" :key="index"> <a class="button is-small is-fullwidth has-background-success-light">
            <span class="icon is-small"><i class="fas fa-check-circle"></i></span>
        </a> </td>
    </tr>
  </tbody>
</table>



    </div>

    <div class="column is-1 has-text-centered has-tooltip-right has-tooltip-danger" data-tooltip="DELETE COURSE">
        <button @click="confirm_course_delete()" class="button is-fullwidth has-text-weight-bold" style="background-color:LIGHTCORAL;color:white">
            <span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     
        </button>
    </div>


<!-- <div v-if="show_delete == true" class="column is-2 has-text-right has-text-centered">
<div class="columns is-multiline is-gapless"> 
    <div class="column is-4 has-text-centered">
        <button @click="toggle_course_delete()" class="button is-fullwidth has-text-weight-bold" style="background-color:LIGHTCORAL;color:white">
            <span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     
        </button>
    </div>

    <div class="column is-8 has-text-centered">
        <button @click="delete_course()" class="button is-fullwidth has-text-weight-bold" style="background-color:OLIVEDRAB;color:white">
            <span class="icon has-text-left"><i class="fas fa-save"></i></span>     
        </button>
    </div>
</div>
</div> -->







</div>






</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import CourseListPond  from '@/components/Comp_Student_Courses_List_Pond';

export default {
        props: [ 'data'],
        components: { CourseListPond },

        data() {
            return {

                 isLoading:false,
                 show_notes:false,

load_pond:false,
data_dates:[],

show_delete:false,
 
            }
        },






methods : {

emit_note_change:function(grpAvg, studAvg, remark) {
// NOTE HAS CHANGED -- UPDATE INFO HERE
    this.data.group_AVG = grpAvg
    this.data.cs_MARK = studAvg
    this.data.cs_REMARK = remark 
},

confirm_course_delete:function() {
    this.$snotify.confirm("Delete Course : " + this.data.cour_TITRE_F, { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
    position: "rightCenter",
        buttons: [
            {text: 'Yes', action: (toast) => this.delete_course_do(toast)},
            {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
        ]
    });
},
delete_course_do:function(toast) {

    this.$snotify.remove(toast.id)
    
    var query = "DELETE FROM MyMEQ_COURSESTUDENT WHERE cs_ID = " + this.data.cs_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(response => { 
        this.show_delete = false
        this.$emit('emit_course_change')
    })

},



toggle_ponderation_notes:function() {

// GET RETARDS 
this.isLoading=true
    var query = `SELECT * FROM myMEQ_SCHEDULE_MAIN WHERE group_ID = ` + this.data.grpID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.data_dates = res.data
        this.show_notes = !this.show_notes
        setTimeout(() => { this.load_pond=true; this.isLoading=false; }, 500);

    });
},


return_course_style_complete:function() {
    if (this.data.group_PUBLIC) {
        return 'background-color:#8FBC8B;'
    } else {
        var dtNow = moment()
        var dtSTART = moment(this.data.group_datSTART)
        var dtEND = moment(this.data.group_datEND)

        if (dtNow > dtSTART) {
            return 'background-color:#F0E68C;'
        }
    }
},
return_course_style_note:function() {

// CHECK EQ FIRST !
if (this.data.cs_REMARK == 'EQ') { return 'has-text-weight-semibold has-background-grey-light has-text-black' }

    if (this.data.group_PUBLIC) {
  
        if (this.data.cs_REMARK == 'EC') {return 'has-text-weight-semibold has-text-danger'}  
        else { return 'has-text-weight-semibold has-text-black' }

    } else {
        var dtNow = moment()
        var dtSTART = moment(this.data.group_datSTART)
        var dtEND = moment(this.data.group_datEND)

        if (dtNow > dtSTART) {
            return 'has-text-grey'
        }
    }
},  
return_course_note:function() {
var dtNow = moment()
var dtSTART = moment(this.data.group_datSTART)
    if (this.data.cs_REMARK == 'EQ') {return ''}
    if (dtNow < dtSTART) { return ''} 
    else { return this.data.cs_MARK + '% '}
},
return_course_average:function() {
var dtNow = moment()
var dtSTART = moment(this.data.group_datSTART)
    if (dtNow < dtSTART) { return ''} 
    else { if(!isNaN(this.data.group_AVG)) { return this.data.group_AVG + '%'}}
},


return_average:function(val) {
    if (!val) {return ''}
    
    if (isNaN(val)) {return ''}
    else {return val + '%'}
},



}, // END METHODS


}
</script>